const state = () => ({
  userUpdated: null
});

const getters = {
  userUpdated(state) {
    return state.userUpdated;
  }
};

const mutations = {
  setUserUpdated(state, payload) {
    state.userUpdated = payload;
  }
};

const actions = {
  setUserUpdated({ commit }, payload) {
    commit('setUserUpdated', payload);
  }
};

export const authUser = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
